import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CtaProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'text';
  /** sm = nav/chrome, md = compact surfaces, lg = page primaries (default). */
  size?: 'sm' | 'md' | 'lg';
  showArrow?: boolean;
  fullWidth?: boolean;
}
const sizeStyles = {
  sm: 'px-3 py-2 text-xs leading-snug sm:px-5 sm:py-2.5 sm:text-sm',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-8 py-4 text-lg'
} as const;
const textSizeStyles = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg'
} as const;
const arrowStyles = {
  sm: 'ml-1.5 h-3.5 w-3.5 sm:ml-2 sm:h-4 sm:w-4',
  md: 'ml-2 h-4 w-4',
  lg: 'ml-2.5 h-5 w-5'
} as const;
export function Cta({
  children,
  variant = 'primary',
  size = 'lg',
  showArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: CtaProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass focus-visible:ring-offset-2 focus-visible:ring-offset-paper disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:shadow-md';
  const variants = {
    // Navy on sand meets WCAG AA (~6.72:1). Sand fill preserved as brand role.
    primary: 'bg-sand hover:bg-sand-dark active:bg-[#b88955] text-navy shadow-md hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'bg-white border-2 border-navy text-navy hover:bg-paper-dark',
    text: 'bg-transparent text-navy hover:text-seaglass p-0 underline underline-offset-4 decoration-seaglass/40 hover:decoration-seaglass'
  };
  const sized = variant === 'text' ? textSizeStyles[size] : sizeStyles[size];
  return <button className={`${baseStyles} ${variants[variant]} ${sized} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-124" data-mp="13ute96mpqwis">
      {children}
      {showArrow && <ArrowRight className={arrowStyles[size]} aria-hidden="true" data-id="element-125" data-mp="2f7vv82sq5o3h" />}
    </button>;
}